import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeFormat from "./timeFormat.js";
export default {
  name: 'selectedDateRange',
  props: {
    // 日期选择中间间隔符
    separator: {
      type: String,
      default: '至'
    },
    // 选择框的大小
    size: {
      type: String,
      default: 'large'
    },
    // 开始时间
    startDate: {
      type: String,
      default: ''
    },
    // 开始时间
    endDate: {
      type: String,
      default: ''
    },
    // 开始禁止时间
    startDisableDate: {
      type: Date,
      default: null
    },
    // 结束禁止时间
    endDisableDate: {
      type: Date,
      default: null
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 显示格式
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    // 选择框的宽度
    width: {
      type: String,
      default: '168'
    },
    firstDayOfWeek: {
      type: Number,
      default: 7
    },
    classStyle: {
      type: String,
      default: ''
    }
  },
  computed: {
    start: {
      get: function get() {
        if (!this.startDate) {
          return '';
        } else if (new Date(this.startDate) == 'Invalid Date') {
          return '';
        }
        return new Date(this.startDate);
      },
      set: function set(val) {
        if (this.end) {
          if (this.end.getTime() < val.getTime()) {
            this.$emit('update:endDate', '');
          }
        }
        this.$emit('update:startDate', val ? timeFormat(val.getTime()) : val);
      }
    },
    end: {
      get: function get() {
        if (!this.endDate) {
          return '';
        } else if (new Date(this.endDate) == 'Invalid Date') {
          return '';
        }
        return new Date(this.endDate);
      },
      set: function set(val) {
        this.$emit('update:endDate', val ? timeFormat(val.getTime()) : val);
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      startOptions: {
        disabledDate: function disabledDate(date) {
          if (!_this.startDisableDate && !_this.endDisableDate) {
            return false;
          }
          if (_this.startDisableDate && !_this.endDisableDate) {
            return !(date.setHours(0, 0, 0, 0) >= _this.startDisableDate.setHours(0, 0, 0, 0));
          }
          if (!_this.startDisableDate && _this.endDisableDate) {
            return !(date.setHours(0, 0, 0, 0) <= _this.endDisableDate.setHours(0, 0, 0, 0));
          }
          if (_this.startDisableDate && _this.endDisableDate) {
            return !(date.setHours(0, 0, 0, 0) >= _this.startDisableDate.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= _this.endDisableDate.setHours(0, 0, 0, 0));
          }
        },
        firstDayOfWeek: this.firstDayOfWeek
      },
      endOptions: {
        disabledDate: function disabledDate(date) {
          if (!_this.endDisableDate && !_this.start) {
            return false;
          }
          if (_this.endDisableDate && !_this.start) {
            return !(date.setHours(0, 0, 0, 0) <= _this.endDisableDate.setHours(0, 0, 0, 0));
          }
          if (!_this.endDisableDate && _this.start) {
            return !(date.setHours(0, 0, 0, 0) >= _this.start.setHours(0, 0, 0, 0));
          }
          if (_this.endDisableDate && _this.start) {
            return !(date.setHours(0, 0, 0, 0) >= _this.start.setHours(0, 0, 0, 0) && date.setHours(0, 0, 0, 0) <= _this.endDisableDate.setHours(0, 0, 0, 0));
          }
        },
        firstDayOfWeek: this.firstDayOfWeek
      }
    };
  }
};